(ns frontend.ux-overhaul.nev.interim.edit-oppo-name-modal
  (:require
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :edit-oppo-name-modal)

(defn view
  [{:keys [shown? close-modal! props state class-name topmost? value]}]
  (let [state-atom (r/atom {:temp-value value})]
    (fn []
      (let [{:keys [label value accounts size color no-close-button? step scale on-change! on-submit! set-edit! show-buttons?]} props
            on-close! (fn []
                        (close-modal!)
                        (when (fn? set-edit!)
                          (set-edit! false)))
            temp-value (:temp-value @state-atom)
            existing-oppo-names (->> @session/oppos
                                     (map :oppo/name)
                                     (set))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         on-close!
          :backdrop      "static"
          :size          size
          :color         color
          :close-button? (not no-close-button?)}
         label
         [:div
          [labelled-input/view
           {:label     (loc/tr :name)
            :data-type :data.type/text-simple
            :value     (or temp-value value)
            :error     (:error-message @state-atom)
            :on-change (fn [new-value]
                         (swap! state-atom assoc :temp-value new-value))
            :on-blur   (fn [new-value]
                         (let [duplicate? (and (not= new-value value)
                                               (contains? existing-oppo-names new-value))]
                           (swap! state-atom assoc
                                  :error? duplicate?
                                  :error-message (when duplicate?
                                                   (str "Deal with name '" new-value "' already exists!")))))}]
          [:p {:class "text-xs text-danger-light-text"}
           (:error-message @state-atom)]]
         [:<>
          [button/secondary-hollow
           {:on-click on-close!}
           (loc/tr :cancel)]
          [button/primary-solid
           {:disabled? (or (:error? @state-atom)
                           (= temp-value value)
                           (not temp-value)
                           (= temp-value ""))
            :on-click  (fn [_]
                         (on-submit! temp-value)
                         (close-modal!))}
           (loc/tr :submit)]]]))))
